module.exports = "<div class=\"report-time hours ng-hide\"><span>00</span> <span>01</span> <span>02</span> <span>03</span> <span>04</span> <span>05</span> <span>06</span> <span>07</span> <span>08</span> <span>09</span> <span>10</span> <span>11</span> <span>12</span> <span>13</span> <span>14</span> <span>15</span> <span>16</span> <span>17</span> <span>18</span> <span>19</span> <span>20</span> <span>21</span> <span>22</span> <span>23</span></div><br><div id=\"report-canvas\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/facts/heatmap/heatmap.component.html
// module id = 334
// module chunks = 0